export interface Session {
  additionalIds:
    | `${number}`
    | `${number},${number}`
    | `${number},${number},${number}`
    | `${number},${number},${number},${number}`
    | `${number},${number},${number},${number},${number}`;
  aud: string;
  email: string;
  exp: number;
  id: number;
  iss: string;
  isAdmin: 'true' | 'false';
  isDemo: 'true' | 'false';
  isPasswordChangeRequired: 'true' | 'false';
  isTenantAdmin: 'true' | 'false';
  isTrial: 'true' | 'false';
  jti: string;
  name: string;
  paymentType: PaymentTypeText;
  relatedUserIds: string;
  subscriptionIsCancelled: 'true' | 'false';
  subscriptionIsValid: 'true' | 'false';
  subscriptionType: '' | 'Free' | 'Basic' | 'Family' | 'Trainee' | 'Pro';
  subscriptionValidUntil: string;
  tenantIds: string;
  username: string;
}

export enum PaymentType {
  Month,
  Year,
}

export enum PaymentTypeText {
  Month = 'Month',
  Year = 'Year',
}

export interface SubscriptionType {
  availableAdditionals: number[];
  description: string;
  emailRestriction?: string;
  id: number;
  level: number;
  name: string;
  paymentType: PaymentType;
  price: number;
}

export enum SubscriptionStatus {
  InProgress = 1,
  Success,
  Error,
}

export interface Additional {
  color: string;
  description: string;
  extraBiotypes: number;
  id: number;
  modules: number[];
  multiple?: boolean;
  name: string;
  paymentType: PaymentType;
  price: number;
  upgradableTo?: number;
}
